import { languageMap } from ".."

languageMap.pcode = languageMap.peoplecode = {
	comments: {
		block: ["/*", "*/"],
	},
}
